import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js'
import React from 'react'
import { Bar } from 'react-chartjs-2'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const PTOChart = (data: any) => {
  const dataChart = data?.data
  const chartData = {
    labels: [
      'Total Token Issued',
      'Total Token Issued Sold',
      'Total Funding Target (USDC)',
      'Total Amount Sold (USDC)',
    ],
    datasets: [
      {
        label: '',
        data: [
          dataChart?.tokenIssued,
          dataChart?.totalIssuedSell,
          dataChart?.fundingTarget,
          dataChart?.totalAmountSell,
        ],
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'],
        borderColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'],
        borderWidth: 1,
      },
    ],
  }

  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      // title: { display: true, text: 'Staked Overview' },
    },
    scales: {
      y: { beginAtZero: true },
    },
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Bar data={chartData} options={options} />
    </div>
  )
}

// comment code

export default PTOChart
